export const nlRcph_V1_0_0_StaticFilesIds = [
  'nl-rcph-v1_0_0-base-general-terms-nl',
  'nl-rcph-v1_0_0-base-general-terms-en',
  'nl-rcph-v1_0_0-cs-rcp-mac-general-terms-nl',
  'nl-rcph-v1_0_0-cs-rcp-mac-general-terms-en',
  'nl-rcph-v1_0_0-cs-rcp-man-general-terms-nl',
  'nl-rcph-v1_0_0-cs-rcp-man-general-terms-en',
  'nl-rcph-v1_0_0-cs-rcp-misc-general-general-terms-nl',
  'nl-rcph-v1_0_0-cs-rcp-misc-general-general-terms-en',
  'nl-rcph-v1_0_0-cs-rcp-tech-general-terms-nl',
  'nl-rcph-v1_0_0-cs-rcp-tech-general-terms-en',
  'nl-rcph-v1_0_0-cs-rcp-misc-legal-general-terms-nl',
  'nl-rcph-v1_0_0-cs-rcp-misc-legal-general-terms-en',
  'nl-rcph-v1_0_0-cs-rcp-misc-accountants-general-terms-nl',
  'nl-rcph-v1_0_0-cs-rcp-misc-accountants-general-terms-en',
  'nl-rcph-v1_0_0-cs-rcp-secu-general-terms-nl',
  'nl-rcph-v1_0_0-cs-rcp-secu-general-terms-en',
  'nl-rcph-v1_0_0-cs-rcp-archi-general-terms-nl',
  'nl-rcph-v1_0_0-cs-rcp-archi-general-terms-en',
  'nl-rcph-v1_0_0-cs-rce-mac-man-tech-misc-general-terms-nl',
  'nl-rcph-v1_0_0-cs-rce-mac-man-tech-misc-general-terms-en',
  'nl-rcph-v1_0_0-cs-rce-legal-acc-archi-secu-general-terms-nl',
  'nl-rcph-v1_0_0-cs-rce-legal-acc-archi-secu-general-terms-en',
  'nl-rcph-v1_0_0-cs-cyber-mac-man-tech-misc-general-terms-nl',
  'nl-rcph-v1_0_0-cs-cyber-mac-man-tech-misc-general-terms-en',
  'nl-rcph-v1_0_0-cs-cyber-legal-acc-archi-secu-general-terms-nl',
  'nl-rcph-v1_0_0-cs-cyber-legal-acc-archi-secu-general-terms-en',
  'nl-rcph-v1_0_0-ipid-mac',
  'nl-rcph-v1_0_0-ipid-man',
  'nl-rcph-v1_0_0-ipid-misc',
  'nl-rcph-v1_0_0-ipid-tech',
  'nl-rcph-v1_0_0-ipid-misc-legal',
  'nl-rcph-v1_0_0-ipid-misc-accountants',
  'nl-rcph-v1_0_0-ipid-secu',
  'nl-rcph-v1_0_0-ipid-archi',
  'nl-rcph-v1_0_0-ipid-rce-mac-man-tech-misc',
  'nl-rcph-v1_0_0-ipid-rce-legal-acc-archi-secu',
  'nl-rcph-v1_0_0-ipid-cyber-mac-man-tech-misc',
  'nl-rcph-v1_0_0-ipid-cyber-legal-acc-archi-secu',
] as const
